module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/hot_ic@3x-e21ec97722bca7a67606c0ef7deae8f4.png";